export class AuthError extends Error {
  constructor (message) {
    super(message)
    this.name = 'AuthError'
  }
}

export const download = (url) => {
  const tmpHref = document.createElement('a')
  tmpHref.href = url
  tmpHref.download = url.substr(url.lastIndexOf('/') + 1)
  document.body.appendChild(tmpHref)
  tmpHref.click()
  document.body.removeChild(tmpHref)
}

export const localeDatePicker = () => {
  return {
    days: 'НЯМ_ДАВАА_МЯГМАР_ЛХАГВА_ПҮРЭВ_БААСАН_БЯМБА'.split('_'),
    daysShort: 'НЯ_ДА_МЯ_ЛХ_ПҮ_БА_БЯ'.split('_'),
    months: '1сар_2сар_3сар_4сар_5сар_6сар_7сар_8сар_9сар_10сар_11сар_12сар'.split('_'),
    monthsShort: '1сар_2сар_3сар_4сар_5сар_6сар_7сар_8сар_9сар_10сар_11сар_12сар'.split('_'),
    firstDayOfWeek: 1
  }
}

export const callApi = async (calls, params, $q, loading, reset=false) => {
  try {
    for (let i = 0; i < calls.length; i++) {
      await calls[i](params)
    }
    if (reset) $q.notify({ type: 'positive' })
  } catch (e) {
    console.log(e)
    $q.notify({ message: e.data.message, type: 'negative' })
    loading.value = false
  } 
}

export const formatNumber = (value=0, fraction=2) => parseFloat(value).toFixed(fraction).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const formatTime = (time) => new Date(time).toLocaleString('en-GB')
export const formatTimeHHMMSS = (time) => new Date(time).toLocaleString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' })

// export const regexPlateNumber = /^[0-9]{4}[АБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмноөпрстуүфхцчшщъыьэюя]{3}$/
export const regexPlateNumber = /^[0-9]{4}[АБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{3}$/

export const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/